import React from 'react';

const Table = ({ data }) => {
  return (
    <table border="1">
      <thead>
        <tr>
          <th>Name</th>
          <th>Prelim (30%)</th>
          <th>Midterm (30%)</th>
          <th>Final (40%)</th>
          <th>Final Rating</th>
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td colSpan="5" style={{ textAlign: 'center' }}>No data yet</td>
          </tr>
        ) : (
          data.map((item) => {
            const finalRating = (
              Number(item.prelim) * 0.3 +
              Number(item.midterm) * 0.3 +
              Number(item.final) * 0.4
            ).toFixed(2);
            return (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.prelim}</td>
                <td>{item.midterm}</td>
                <td>{item.final}</td>
                <td>{finalRating}</td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export default Table;